import script from "./Bridge.vue?vue&type=script&setup=true&lang=js"
export * from "./Bridge.vue?vue&type=script&setup=true&lang=js"

import "./Bridge.vue?vue&type=style&index=0&id=23f63710&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f63710"]])

export default __exports__